module.exports = __webpack_public_path__ + "static/media/Investor-DAVE FOULKES_1646333520788.75d716d8.vtt";